export default "__VITE_ASSET__f3b86042__"